import { ReactElement, useState, useEffect, useRef } from "react";
import appServices from "../services/app-services/appServices";

interface Props {
  file?: File
  id: number;
  alt?: string;
  style?: any;
  onImageLoaded?: (file: File | undefined) => void;
}

function SampleImage({ file, id, alt, style, onImageLoaded }: Props): ReactElement {
  const [imageUrl, setImageUrl] = useState<string>('');
  const imgRef = useRef<any>(null);

  const defaultImage = require("../assets/images/default.png");

  useEffect(() => {
    if (id == null) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        if (file) {
          setImageUrl(URL.createObjectURL(file));
        } else {
          appServices.getSampleImage(id).then((_file: File) => {
            setImageUrl(URL.createObjectURL(_file));
            if (onImageLoaded) {
              onImageLoaded(_file);
            }
          }).catch(e => {
            // pass
          })
        }
        observer.disconnect();
      }
    });

    observer.observe(imgRef.current);

    return () => observer.disconnect();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <img src={imageUrl ?? defaultImage} alt={alt} style={style} ref={imgRef} />
  );
};

export default SampleImage;
